import { LocalStackChaosExperiment } from '@localstack/types';

export const isExperimentRunning = (experiment: LocalStackChaosExperiment): boolean =>
  Array.isArray(experiment)
    ? !!experiment?.length
    : typeof experiment?.latency === 'number' && experiment.latency !== 0;
